import { render, staticRenderFns } from "./Trivia10.vue?vue&type=template&id=c98fdb06&"
import script from "./Trivia10.vue?vue&type=script&lang=js&"
export * from "./Trivia10.vue?vue&type=script&lang=js&"
import style0 from "./Trivia10.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports